import type { ButtonProps } from '@theme-ui/components';
import { Button, Text } from '@theme-ui/components';
import styled from '@emotion/styled';

import { fadeIn } from '@app/styles/animations';
import { rem } from '@app/styles/theme/layout';

interface CardProps {
  highlight?: boolean;
  isDisabled?: boolean;
  hasError?: boolean;
}

export const Card = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'highlight',
})<ButtonProps & CardProps>`
  min-width: ${rem(150)};
  min-height: ${rem(119)};
  border: ${rem(1)} solid ${({ theme }) => theme.colors.mediumGray};
  border-radius: ${({ theme }) => theme.radii.normal};
  background: ${({ theme }) => theme.colors.white};
  font-size: ${rem(14)};
  line-height: 1.5;
  cursor: pointer;
  text-align: left;
  transition: all 0.15s cubic-bezier(0.33, 1, 0.68, 1);
  color: initial;

  &:hover {
    box-shadow: 0 ${rem(1)} ${rem(4)} ${({ theme }) => theme.colors.lightGray};
    border-color: ${({ theme }) => theme.colors.lightBlue};
  }

  &:focus-visible {
    transition: none;
    box-shadow: none;
    border-color: ${({ theme }) => theme.colors.mediumGray};
    outline: ${rem(1)} solid ${({ theme }) => theme.colors.brightOrange};
    outline-offset: ${rem(1)};
  }

  ${(props) =>
    props.highlight && `border-color: ${props.theme.colors.lightBlue};`}
  ${(props) => props.hasError && `border-color: ${props.theme.colors.red};`}
  ${(props) => props.isDisabled && 'opacity: 0.7;'}
`;

export const CheckIconWrapper = styled.div`
  position: absolute;
  right: ${rem(16)};

  & svg {
    animation: ${fadeIn} 0.15s cubic-bezier(0.33, 1, 0.68, 1);
  }
`;

export const Title = styled(Text)`
  width: 85%;
  font-size: ${rem(14)};
  margin-bottom: ${rem(16)};
`;

export const GreyedOutText = styled(Text)`
  color: ${({ theme }) => theme.colors.labelGray};
  font-size: ${rem(13)};
  text-decoration-line: line-through;
`;

export const BoldText = styled(Text)`
  font-size: ${rem(22)};
  font-weight: 600;
`;

export const CardLabel = styled.div<{ color: string; textColor: string }>`
  font-weight: 500;
  font-size: ${rem(14)};
  padding: ${rem(6)} ${rem(16)};
  position: absolute;
  bottom: ${rem(-33)};
  border-radius: ${({ theme }) =>
    `0 0 ${theme.radii.normal} ${theme.radii.normal}`};
  transform: translateX(-1px) translateY(-2px);
  width: calc(100% + ${rem(2)});

  ${(props) => props.color && `background-color: ${props.color};`}
  ${(props) => props.textColor && `color: ${props.textColor};`};
`;
